import React from "react";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import { useParams } from "react-router-dom";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import {
  fetchCampaign,
  ANALYTICS_UNAVAILABLE_CAMPAIGN_NOT_FOUND,
} from "../../api_calls/campaignRequests";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../Store/actions";
import AnalyticsDashboard from "./Reports/AnalyticsDashboard";
import { fetchReportTabsConfigForPublishedReport } from "../../api_calls/ReportSettings";
import CampaignAnalyticsEmptyState from "./CampaignAnalyticsEmptyState";

/**
 * Brand View of campaign analytics.
 *
 * Sets brand_report_view so the load path seeds embedded_* from brand_filters
 * (Brand Report constraints) instead of full retailer catalogs.
 */
const BrandReportView = () => {
  const dispatchAction = useDispatch();
  const campaignDetails = useSelector((state) => state.userSelections);
  const { id } = useParams();

  const hasCampaignDetail = typeof campaignDetails.campaign_detail !== "undefined";
  const storesScopeEmpty = campaignDetails.analytics_campaign_stores_scope_empty === true;
  const unavailableReason = campaignDetails.analytics_report_unavailable_reason;
  const hasBrandFilters = typeof campaignDetails.brand_filters !== "undefined";

  const reportTabsConfig =
    hasCampaignDetail && hasBrandFilters
      ? fetchReportTabsConfigForPublishedReport("Brand")
      : [];

  const showEmptyState =
    storesScopeEmpty === true &&
    (hasCampaignDetail === true || unavailableReason === ANALYTICS_UNAVAILABLE_CAMPAIGN_NOT_FOUND);

  React.useEffect(() => {
    dispatchAction(
      updateStateData({
        brand_report_view: true,
      })
    );
    fetchCampaign(id, "all", "Brand", "brand_report");
  }, []);

  return (
    <StyledMainBox
      component="main"
      sx={
        showEmptyState === true
          ? {
              flex: 1,
              alignSelf: "stretch",
              minWidth: 0,
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
            }
          : {}
      }
    >
      {showEmptyState === true && (
        <CampaignAnalyticsEmptyState reason={unavailableReason} />
      )}

      {hasCampaignDetail === true &&
        storesScopeEmpty !== true &&
        hasBrandFilters === true &&
        reportTabsConfig.length !== 0 && (
          <AnalyticsDashboard
            reportSettingArr={reportTabsConfig}
            viewMode={"Brand"}
            preview={false}
          />
        )}
    </StyledMainBox>
  );
};

export default AccessControl(BrandReportView, [
  "campaign_reports_performance_can_view",
  "campaign_reports_impression_can_view",
], [], ["campaigns_section", "campaign_list"]);
